import { ApplicationConfig, importProvidersFrom, inject, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withEnabledBlockingInitialNavigation, withInMemoryScrolling } from '@angular/router';
import Material from '@primeng/themes/material';

import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import { routes } from './app.routes';
import { HttpClient, provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { APOLLO_NAMED_OPTIONS, provideApollo } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';
import { InMemoryCache } from '@apollo/client/core';
import { environment } from './environments/enviroment';
import { authInterceptor } from './interceptors/auth.interceptor';
import { MessageService, ConfirmationService } from 'primeng/api';

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

const uri = environment.apiUrl + 'company/report/';
const uriAuth = environment.apiUrl + 'auth/report/';
const newBackGraphqlBase = environment.apiUrlNewBack + 'graphql/';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withInMemoryScrolling({ anchorScrolling: 'enabled', scrollPositionRestoration: 'enabled' }), withEnabledBlockingInitialNavigation()),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: Material,
        options: {
          darkModeSelector: '.my-app-dark'
        }
      }
    }),
    MessageService, // Provider global para PrimeNG MessageService
    ConfirmationService, // Provider global para PrimeNG ConfirmationService
    provideHttpClient(
      withFetch()
      // Interceptor deshabilitado - usar validación manual en lugares específicos
      // withInterceptors([authInterceptor])
    ),
    importProvidersFrom([
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: (createTranslateLoader),
          deps: [HttpClient]
        },
        defaultLanguage: 'es'
      })
    ]),
    provideApollo(() => {
      try {
        const httpLink = inject(HttpLink);
        return {
          link: httpLink.create({ uri }),
          cache: new InMemoryCache(),
        };
      } catch (e) {
        console.error('Apollo init error', e);
        throw e;
        // return
      }
    }),
    // Apollo named clients
    {
      provide: APOLLO_NAMED_OPTIONS,
      useFactory: (httpLink: HttpLink) => ({
        auth: {
          cache: new InMemoryCache(),
          link: httpLink.create({ uri: uriAuth }),
        },
        userPlatforms: {
          cache: new InMemoryCache(),
          link: httpLink.create({ uri: newBackGraphqlBase + 'user-platforms' }),
        },
        organizations: {
          cache: new InMemoryCache(),
          link: httpLink.create({ uri: newBackGraphqlBase + 'organizations' }),
        },
        areas: {
          cache: new InMemoryCache(),
          link: httpLink.create({ uri: newBackGraphqlBase + 'areas' }),
        },
        workspaces: {
          cache: new InMemoryCache(),
          link: httpLink.create({ uri: newBackGraphqlBase + 'workspaces' }),
        },
        users: {
          cache: new InMemoryCache(),
          link: httpLink.create({ uri: newBackGraphqlBase + 'users' }),
        },
      }),
      deps: [HttpLink],
    },
  ]
};
